import { useEffect, useState } from "react";
import { convertTimeTo12HourSystem } from "../../templates/stock-faqs/src/utils/helperFunctions";
import { getIvrDetails } from "../services/IVR/ivr.service";
import { isTokenPresent } from "../utils/cookieHelper";
import { checkIfIVRAvailable } from "../utils/helperFunctions";

const useGetIVRDetails = () => {
  const [ivrDetails, setIVRDetails] = useState({});

  useEffect(() => {
    async function getDetails() {
      try {
        const ivrData = await getIvrDetails();
        setIVRDetails({
          ...ivrData.ivrConfig,
          businessStartTime: convertTimeTo12HourSystem(
            ivrData.ivrConfig?.businessStartTime ||
              "08:00 AM"
          ),
          businessEndTime: convertTimeTo12HourSystem(
            ivrData.ivrConfig?.businessEndTime || "05:00 PM"
          ),
          isAvailable: checkIfIVRAvailable(
            ivrData.ivrConfig?.businessStartTime,
            ivrData.ivrConfig?.businessEndTime
          ),
          expectedWaitTime: !isNaN(
            ivrData.ivrConfig?.expectedWaitTime / 60
          )
            ? ivrData.ivrConfig?.expectedWaitTime / 60
            : "5", // converting wait time in minutes
        });
      } catch {
        return null;
      }
    }

    if (isTokenPresent()) getDetails();
  }, []);

  return ivrDetails;
};

export default useGetIVRDetails;
